import { IChangelogRecord } from "../../interfaces";

interface State {
  changelogRecords: IChangelogRecord[];
  version: string;
  isLoading: boolean;
  isUpdating: boolean;
  isVersionMissingReleaseNotes: boolean;
  isChangelogConfirmationModalOpen: boolean;
}

export const DEFAULT_CHANGELOG_STATE: State = {
  changelogRecords: [],
  version: "",
  isLoading: true,
  isUpdating: false,
  isVersionMissingReleaseNotes: false,
  isChangelogConfirmationModalOpen: false,
};

export enum Actions {
  ADD_CHANGELOG_RECORD = "ADD_CHANGELOG_RECORD",
  DELETE_CHANGELOG_RECORD = "DELETE_CHANGELOG_RECORD",
  SET_VERSION_DATA = "SET_VERSION_DATA",
  TOGGLE_CHANGELOG_CONFIRMATION_MODAL = "OPEN_CHANGELOG_CONFIRMATION_MODAL",
  START_CHANGELOG_UPDATE = "START_CHANGELOG_UPDATE",
  FINISH_CHANGELOG_UPDATE = "FINISH_CHANGELOG_UPDATE",
}

type ActionsType =
  | {
      type: Actions.ADD_CHANGELOG_RECORD;
      payload: IChangelogRecord;
    }
  | {
      type: Actions.DELETE_CHANGELOG_RECORD;
      payload: IChangelogRecord;
    }
  | {
      type: Actions.SET_VERSION_DATA;
      payload: Pick<State, "version" | "isVersionMissingReleaseNotes">;
    }
  | {
      type: Actions.TOGGLE_CHANGELOG_CONFIRMATION_MODAL;
    }
  | {
      type: Actions.FINISH_CHANGELOG_UPDATE;
    }
  | {
      type: Actions.START_CHANGELOG_UPDATE;
    };

export const changelogReducer = (state: State, action: ActionsType): State => {
  switch (action.type) {
    case Actions.ADD_CHANGELOG_RECORD: {
      return {
        ...state,
        changelogRecords: [...state.changelogRecords, action.payload],
      };
    }

    case Actions.DELETE_CHANGELOG_RECORD: {
      const notDelatedChangelogRecords = state.changelogRecords.filter(
        ({ id: changelogRecordId }) => changelogRecordId !== action.payload.id
      );

      return { ...state, changelogRecords: notDelatedChangelogRecords };
    }

    case Actions.SET_VERSION_DATA: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    }

    case Actions.TOGGLE_CHANGELOG_CONFIRMATION_MODAL: {
      return {
        ...state,
        isChangelogConfirmationModalOpen:
          !state.isChangelogConfirmationModalOpen,
      };
    }

    case Actions.START_CHANGELOG_UPDATE: {
      return {
        ...state,
        isUpdating: true,
      };
    }

    case Actions.FINISH_CHANGELOG_UPDATE: {
      return {
        ...state,
        isUpdating: false,
        isVersionMissingReleaseNotes: false,
        isChangelogConfirmationModalOpen: false,
        changelogRecords: [],
      };
    }

    default:
      throw new Error("Such action is not supported");
  }
};
